import {
  SecondhandsApiFactory,
  V1SecondhandGateway,
  V1SecondhandSensor,
  V1SecondhandTablet,
} from '@vacancorp/enterprise-for-client.vacanservice.com'
import { SecondhandGateway, SecondhandSensor, SecondhandTablet } from '@/models'
import { api, ApiResponse, ListResponse, createApiError } from './base'

function createSecondhandGateways(rawSecondhands?: V1SecondhandGateway[]): SecondhandGateway[] {
  if (!rawSecondhands) return []

  return rawSecondhands.map((c: V1SecondhandGateway): SecondhandGateway => {
    return new SecondhandGateway({
      mac: c.mac,
      startDate: c.startDate,
      endDate: c.endDate,
    })
  })
}

function createSecondhandSensors(rawSecondhands?: V1SecondhandSensor[]): SecondhandSensor[] {
  if (!rawSecondhands) return []

  return rawSecondhands.map((c: V1SecondhandSensor): SecondhandSensor => {
    return new SecondhandSensor({
      mac: c.mac,
      startDate: c.startDate,
      endDate: c.endDate,
    })
  })
}

function createSecondhandTablets(rawSecondhands?: V1SecondhandTablet[]): SecondhandTablet[] {
  if (!rawSecondhands) return []

  return rawSecondhands.map((c: V1SecondhandTablet): SecondhandTablet => {
    return new SecondhandSensor({
      mac: c.mac,
      startDate: c.startDate,
      endDate: c.endDate,
    })
  })
}

export const NewSecondhandsApiFunc = () => {
  const webAdapter = SecondhandsApiFactory(undefined, api.defaults.baseURL, api)

  return {
    adminListSecondhandGateways: async (page?: number): Promise<ApiResponse<ListResponse<SecondhandGateway>>> => {
      let data, currentPage, totalPage, err

      try {
        const res = await webAdapter.adminListSecondhandGateways(page)
        data = createSecondhandGateways(res.data.gateways)
        currentPage = res.data.currentPage
        totalPage = res.data.totalPage
      } catch (e) {
        data = [] as SecondhandGateway[]
        err = createApiError(e)
      }

      return {
        data: {
          list: data,
          currentPage: currentPage || 1,
          totalPage: totalPage || 1
        },
        err,
      }
    },

    adminListSecondhandSensors: async (page?: number): Promise<ApiResponse<ListResponse<SecondhandSensor>>> => {
      let data, currentPage, totalPage, err

      try {
        const res = await webAdapter.adminListSecondhandSensors(page)
        data = createSecondhandSensors(res.data.sensors)
        currentPage = res.data.currentPage
        totalPage = res.data.totalPage
      } catch (e) {
        data = [] as SecondhandSensor[]
        err = createApiError(e)
      }

      return {
        data: {
          list: data,
          currentPage: currentPage || 1,
          totalPage: totalPage || 1
        },
        err,
      }
    },

    adminListSecondhandTablets: async (page?: number): Promise<ApiResponse<ListResponse<SecondhandTablet>>> => {
      let data, currentPage, totalPage, err

      try {
        const res = await webAdapter.adminListSecondhandTablets(page)
        data = createSecondhandTablets(res.data.tablets)
        currentPage = res.data.currentPage
        totalPage = res.data.totalPage
      } catch (e) {
        data = [] as SecondhandTablet[]
        err = createApiError(e)
      }

      return {
        data: {
          list: data,
          currentPage: currentPage || 1,
          totalPage: totalPage || 1
        },
        err,
      }
    }
  }
}
